module.exports = __webpack_public_path__ + "img/panelView_defaultBG_special_3_3.31ad6c7b.png";